import PropTypes from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { formatAddress } from '../../../helpers/address';

const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.vars.palette.primary.black,
  lineHeight: '31px',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '180px',
}));

const StyledAddressTypography = styled(Typography)(({ theme }) => ({
  color: theme.vars.palette.primary.gray,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
}));

const AddressView = ({
  address = {},
  inline = false,
  titleWidth,
  boxWidth = '100%',
  pickupPoint = {},
  id,
}) => {
  const formattedAddress = formatAddress(
    {
      shortName: pickupPoint.pickupLocation?.shortName,
      ...address,
    },
    inline
  );

  return (
    <Box
      id={`addressView_${id}`}
      data-testid='addressView'
      sx={{ width: boxWidth }}
    >
      {inline ? (
        <Typography variant='body2' sx={{ wordWrap: 'break-word' }}>
          {formattedAddress}
        </Typography>
      ) : (
        <>
          <Tooltip
            title={
              pickupPoint.pickupLocation?.shortName ||
              address.organisation ||
              ''
            }
          >
            <StyledTypography
              sx={{ width: titleWidth }}
              variant='h6'
              component='h2'
            >
              {pickupPoint.pickupLocation?.shortName || address.organisation}
            </StyledTypography>
          </Tooltip>
          <StyledAddressTypography variant='body2'>
            {formattedAddress}
          </StyledAddressTypography>
        </>
      )}
    </Box>
  );
};

AddressView.propTypes = {
  inline: PropTypes.bool,
  titleWidth: PropTypes.string,
  address: PropTypes.shape({
    organisation: PropTypes.string,
    property: PropTypes.string,
    street: PropTypes.string,
    town: PropTypes.string,
    county: PropTypes.string,
    postcode: PropTypes.string,
  }),
  id: PropTypes.string.isRequired,
};

export default AddressView;
